import { VALIDATION_PATTERNS, VALIDATION_MESSAGES } from 'constants/index';


export const validators = {
  required: (value: any) => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return VALIDATION_MESSAGES.REQUIRED;
    }
    return true;
  },

  email: (value: string) => {
    if (!VALIDATION_PATTERNS.EMAIL.test(value)) {
      return VALIDATION_MESSAGES.EMAIL_INVALID;
    }
    return true;
  },

  password: (value: string) => {
    if (!value) return true;
    if (!VALIDATION_PATTERNS.PASSWORD.test(value)) {
      return VALIDATION_MESSAGES.PASSWORD_WEAK;
    }
    return true;
  },

  minLength: (min: number) => (value: string) => {
    if (!value) return true;
    if (value.length < min) {
      return VALIDATION_MESSAGES.MIN_LENGTH(min);
    }
    return true;
  },

  maxLength: (max: number) => (value: string) => {
    if (!value) return true;
    if (value.length > max) {
      return VALIDATION_MESSAGES.MAX_LENGTH(max);
    }
    return true;
  },

  match: (fieldName: string, getValues: () => any) => (value: string) => {
    const values = getValues();
    if (value !== values[fieldName]) {
      return VALIDATION_MESSAGES.PASSWORD_MISMATCH;
    }
    return true;
  },

  url: (value: string) => {
    if (!value) return true;
    if (!VALIDATION_PATTERNS.URL.test(value)) {
      return 'Please enter a valid URL';
    }
    return true;
  },

  phone: (value: string) => {
    if (!value) return true;
    if (!VALIDATION_PATTERNS.PHONE.test(value)) {
      return 'Please enter a valid phone number';
    }
    return true;
  },
};

export default validators;

